/* RESPONSIBLE TEAM: team-inbox-management */
import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import type AppService from 'embercom/services/app-service';

export default class WorkforceController extends Controller {
  queryParams = [];

  @service declare appService: AppService;
  @service declare navbarCollapsingService: $TSFixMe;

  get submenuCollapsed(): boolean {
    return this.navbarCollapsingService.collapsed;
  }
}
